import { NavLink } from 'react-router-dom'

function CompHome() {

    return (
        <div className="d-flex justify-content-center py-5 bg-light">
            <div className="d-flex align-items-start flex-column">
                <NavLink to="us" className="btn-psn btn btn-outline-secondary mb-4">PSN US</NavLink>
                <NavLink to="br" className="btn-psn btn btn-outline-secondary mb-4">PSN BR</NavLink>
                <NavLink to="data" className="btn-psn btn btn-outline-secondary">PSN DATA</NavLink>
            </div>
        </div>
    )
}

export default CompHome